import { deepClone, pick, setAtPath } from '@sitecore-search/common';
import CookieHandler from './cookieHandler.js';
import LocalStorageHandler from './localStorageHandler.js';
const DEFAULT_EXPIRY = 300000;
let storageStrategy;
class ContextEntity {
    constructor(useStorage, type) {
        Object.defineProperty(this, "type", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(this, "contextValue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        if (useStorage && window.localStorage) {
            storageStrategy = new LocalStorageHandler();
        }
        else {
            storageStrategy = new CookieHandler();
        }
        this.type = type;
    }
    set(key, value, expire) {
        setAtPath(this.contextValue, String(key), value);
        storageStrategy.set('__ec', this.contextValue, expire || DEFAULT_EXPIRY);
    }
    get(key) {
        return this.contextValue[key];
    }
    remove(key) {
        if (this.contextValue && this.contextValue[key]) {
            delete this.contextValue[key];
        }
        storageStrategy.set('__ec', this.contextValue, DEFAULT_EXPIRY);
    }
    transformJson(json) {
        return json;
    }
    toJson(...props) {
        if (props.length === 0) {
            return this.transformJson(deepClone(this.contextValue));
        }
        return this.transformJson(pick(deepClone(this.contextValue), props));
    }
}
export default ContextEntity;
